
/* CHALK Conversion Optimization JS
   (Email popup removed — the theme's native newsletter popup handles it.
    Running both caused a double-popup collision at 8 seconds.) */
(function() {
  'use strict';

  /* ── Value Badge — honest value props on product pages ── */
  function initValueBadge() {
    var addToCartBtn = document.querySelector('form[action*="/cart/add"] button[type="submit"], .product-form__submit, .add-to-cart');
    if (!addToCartBtn) return;

    var badge = document.createElement('div');
    badge.className = 'chalk-stock-badge';

    var meta = document.querySelector('meta[property="og:title"]');
    var title = meta ? meta.content : '';

    if (title.toLowerCase().includes('collection') || title.toLowerCase().includes('bundle')) {
      badge.textContent = '★ Save $15 vs buying all 4 individually';
    } else {
      badge.textContent = '⚡ Full 8 fl oz — 2x the size of a designer bottle';
    }

    addToCartBtn.parentNode.insertBefore(badge, addToCartBtn.nextSibling);
  }

  /* ── Mobile Sticky Add-to-Cart Bar ── */
  function initStickyAtc() {
    if (window.innerWidth > 768) return;
    var form = document.querySelector('form[action*="/cart/add"]');
    if (!form) return;
    var origBtn = form.querySelector('button[type="submit"]');
    if (!origBtn) return;

    var titleEl = document.querySelector('.product-single__title, h1');
    var priceEl = document.querySelector('.product__price, [data-product-price], .product-single__price');
    var titleText = titleEl ? titleEl.textContent.trim() : '';
    var priceText = priceEl ? priceEl.textContent.trim().split('\n')[0] : '';

    var bar = document.createElement('div');
    bar.className = 'chalk-sticky-atc';
    bar.innerHTML = '<div class="chalk-sticky-atc__info"><span class="chalk-sticky-atc__title"></span><span class="chalk-sticky-atc__price"></span></div><button type="button" class="chalk-sticky-atc__btn">ADD TO CART</button>';
    bar.querySelector('.chalk-sticky-atc__title').textContent = titleText;
    bar.querySelector('.chalk-sticky-atc__price').textContent = priceText;
    document.body.appendChild(bar);

    bar.querySelector('.chalk-sticky-atc__btn').addEventListener('click', function() {
      origBtn.click();
      var b = bar.querySelector('.chalk-sticky-atc__btn');
      b.textContent = 'ADDED ✓';
      setTimeout(function() { b.textContent = 'ADD TO CART'; }, 2500);
    });

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            bar.classList.remove('visible');
          } else if (entry.boundingClientRect.top < 0) {
            bar.classList.add('visible');
          }
        });
      }, { threshold: 0 });
      io.observe(origBtn);
    }
  }

  /* ── Init ── */
  function initAll() {
    initValueBadge();
    initStickyAtc();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
